import { SearchApi, SearchRequestType } from 'legacy/lut/classes/services/api/SearchApi'
import { appGetState } from 'legacy/lut/store'

import { IUser } from 'core-components/sitebuilder/models/IUser'
import {
  BaseFetcher,
  ICrudImplementation,
  TCreateFunction,
  TFetcher,
  TUpdateFunction,
} from 'core-components/types'
import { IFetchResult, IFormStore } from 'core/classes/helpers/store/Interfaces'

export class SearchAPIFetcher<T> extends BaseFetcher<T> implements ICrudImplementation<T> {
  constructor(
    public keyField: string,
    private spec: { type: SearchRequestType }
  ) {
    super()
    this.user = appGetState().user
    this.searchApi = new SearchApi(this.user)
  }

  private user: IUser
  private searchApi

  private dataStore: IFormStore<T> = {
    data: [],
    queries: {},
    groups: [],
  } as IFormStore<T>

  public read: TFetcher<T> = async (query, filter, sort, paging) => {
    const cache = (await this.readFromStore(query)) as {
      items: T[]
      total: number
      unknownRoots: number[]
      groups: any[]
    }
    if (cache && cache.items && cache.items.length) {
      return cache
    }
    if (filter && filter.filters[0]) {
      // TODO Add caching queue functionalityr
      const fetchResult = await this.searchApi.advancedSearchForFetcher(
        filter,
        this.spec.type,
        paging
      )
      await this.saveToStore(query, {
        items: fetchResult as any,
        total: 0,
      })
      return {
        items: fetchResult as any,
        total: 0,
      }
    } else {
      return {
        items: [],
        total: 0,
      }
    }
  }

  public saveToStore = async (
    query: string,
    data: {
      items: T[]
      total: number
    }
  ) => {
    await this.mergeFn(query, data)
  }

  public readById = async () => {
    return {
      items: [],
      total: 0,
    }
  }
  public create: TCreateFunction<T> = async () => {
    return []
  }
  public update: TUpdateFunction<T> = async () => {
    return []
  }

  private mergeFn = (query: string, data: IFetchResult<T>) => {
    const currentForm: T[] = this.dataStore.data || []

    data.items.forEach((row, curIndex) => {
      const ind = currentForm.findIndex((curRow) => curRow[this.keyField] === row[this.keyField])
      if (ind > -1) {
        //@ts-ignore
        data.items.splice(curIndex, 1, Object.assign(currentForm[ind], row))
      } else {
        currentForm.push(row)
      }
    })
    this.dataStore.data = this.dataStore.data.slice()
    const queries = this.dataStore.queries

    if (query && data && data.items) {
      queries[query] = data
      this.dataStore = {
        ...this.dataStore,
        queries,
      }
    }

    return {
      ...this.dataStore,
    }
  }

  private readFromStore = async (query: string) => {
    return this.dataStore.queries[query]
  }

  public clone(): SearchAPIFetcher<T> {
    return new SearchAPIFetcher(this.keyField, this.spec)
  }
}
